import React, { Fragment } from "react";

const PlanActivitySyncTable = ({ activitydata }) => {

    return (
        <Fragment>
            <p>
                <strong>Total Record:</strong> <span>{activitydata.length}</span>
            </p>
            <div className="table-responsive mt-3">
                <table className="table table-stripped table-hover">
                    <thead className="thead-light">
                        <tr>
                            <th>Profile ID</th>
                            <th>Event Name</th>
                            <th>Event Date</th>
                            <th>Event Desc</th>
                            <th>Email</th>
                        </tr>
                    </thead>
                    <tbody>
                        {activitydata.length > 0 ? (
                            activitydata.map((row, index) => (
                                <tr key={index}>
                                    <td>{row.profile_id}</td>
                                    <td>{row.event_name}</td>
                                    <td>{row.event_date}</td>
                                    <td>{row.event_desc}</td>
                                    <td>{row.email}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" className="text-center">
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </Fragment>
    );
};

export default PlanActivitySyncTable;
